module.exports = __webpack_public_path__ + "img/djuliImageSquared.18316d12.png";